/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../types/graph';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateBasicsMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.UpdateBasicsInput;
}>;


export type UpdateBasicsMutation = { __typename?: 'Mutation', updateBasics: { __typename?: 'Basics', id: string, dateOfBirth: string | null, gender: SchemaTypes.Gender | null, stateId: number | null } | null };


export const UpdateBasicsDocument = gql`
    mutation UpdateBasics($input: UpdateBasicsInput!) {
  updateBasics(input: $input) {
    id
    dateOfBirth
    gender
    stateId
  }
}
    `;
export type UpdateBasicsMutationFn = Apollo.MutationFunction<UpdateBasicsMutation, UpdateBasicsMutationVariables>;
export function useUpdateBasicsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBasicsMutation, UpdateBasicsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBasicsMutation, UpdateBasicsMutationVariables>(UpdateBasicsDocument, options);
      }
export type UpdateBasicsMutationHookResult = ReturnType<typeof useUpdateBasicsMutation>;
export type UpdateBasicsMutationResult = Apollo.MutationResult<UpdateBasicsMutation>;
export type UpdateBasicsMutationOptions = Apollo.BaseMutationOptions<UpdateBasicsMutation, UpdateBasicsMutationVariables>;